<app-alert-container></app-alert-container>

<!-- Global sync indicator -->
@if (
  scoreBufferService.pendingCount() > 0 ||
  scoreBufferService.processingCount() > 0 ||
  scoreBufferService.offlineCount() > 0
  ) {
  <div
    class="sync-indicator"
    >
    <!-- Offline status (priority display when offline) -->
    @if (
      !scoreBufferService.isOnline() || scoreBufferService.offlineCount() > 0
      ) {
      <span
        class="badge badge-danger"
        >
        <i class="fa fa-wifi"></i>
        {{ scoreBufferService.offlineCount() }} scores offline
        @if (!scoreBufferService.isOnline()) {
          <span> - No connection</span>
        }
      </span>
    }
    <!-- Online syncing (only show when online and no offline scores) -->
    @if (
      scoreBufferService.isOnline() &&
      scoreBufferService.offlineCount() === 0 &&
      (scoreBufferService.pendingCount() > 0 ||
      scoreBufferService.processingCount() > 0)
      ) {
      <span
        class="badge badge-warning"
        >
        <i class="fa fa-sync fa-spin"></i>
        Syncing
        {{
        scoreBufferService.pendingCount() + scoreBufferService.processingCount()
        }}
        changes...
      </span>
    }
    <!-- Restoring offline scores when online -->
    @if (
      scoreBufferService.isOnline() &&
      scoreBufferService.offlineCount() > 0 &&
      (scoreBufferService.pendingCount() > 0 ||
      scoreBufferService.processingCount() > 0)
      ) {
      <span
        class="badge badge-info ml-1"
        >
        <i class="fa fa-cloud-upload fa-spin"></i>
        Syncing offline scores...
      </span>
    }
  </div>
}

<!-- Debug panel for testing offline functionality -->
@if (isScoresMode() && isDebugPanelVisible()) {
  <div class="debug-trigger">
    <!-- Small debug button -->
    <button class="btn btn-xs btn-outline-secondary debug-btn">
      <i class="fa fa-bug"></i>
    </button>

    <!-- Debug panel - shows on hover -->
    <div class="debug-panel">
      <div><strong>Buffer Status:</strong></div>
      <div>Online: {{ scoreBufferService.isOnline() ? "Yes" : "No" }}</div>
      <div>Pending: {{ scoreBufferService.pendingCount() }}</div>
      <div>Processing: {{ scoreBufferService.processingCount() }}</div>
      <div>Offline: {{ scoreBufferService.offlineCount() }}</div>
      <div class="mt-2">
        <button (click)="forceBufferProcessing()" class="btn btn-xs btn-primary">
          Force Process
        </button>
        <button (click)="getOfflineStatus()" class="btn btn-xs btn-info ml-1">
          Log Status
        </button>
      </div>
      <div class="mt-1">
        <button (click)="forceSyncOfflineScores()" class="btn btn-xs btn-success">
          Sync Offline
        </button>
      </div>
      <div class="mt-1">
        <button (click)="simulateOffline()" class="btn btn-xs btn-warning">
          Simulate Offline
        </button>
        <button (click)="simulateOnline()" class="btn btn-xs btn-secondary ml-1">
          Simulate Online
        </button>
      </div>
    </div>
  </div>
}

<app-shot-list-modal
  (shotsUpdated)="onShotsUpdated($event)"
></app-shot-list-modal>
<app-player-search-modal
  [groups]="groups"
  (playerSelected)="onSearchPlayerSelected($event)"
></app-player-search-modal>
<div class="ibox float-e-margins">
  <div class="ibox-title">
    <!--Filter row: Group, Player, ScorecardMode, Refresh-->
    <!-- Course dropdown: visible for selection in Scorecard -->
    <div class="btn-group">
      <button
        id="selectCourse"
        [disabled]="!selectedTournament()"
        data-toggle="dropdown"
        class="btn btn-primary btn-outline dropdown-toggle"
        >
        {{ selectedCourse()?.courseName }}
        <span class="caret"></span>
      </button>
      <ul id="courseDropdown" class="dropdown-menu">
        @for (course of courses; track course) {
          <li>
            <a href="#" (click)="selectCourse(course); $event.preventDefault()">
              <span>{{ course.courseName }}</span>
            </a>
          </li>
        }
      </ul>
    </div>
    <div class="btn-group">
      <button
        id="selectGroup"
        [disabled]="!selectedRound()"
        data-toggle="dropdown"
        class="btn btn-primary btn-outline dropdown-toggle"
        >
        Group {{ selectedGroupSignal()?.number }}
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        @for (group of groups; track group) {
          <li>
            <a href="#" (click)="selectGroup(group); $event.preventDefault()">
              <span>Group {{ group.number }}</span>
            </a>
          </li>
        }
      </ul>
    </div>
    @if (scorecardMode !== 'scores' && this.players.length > 0) {
      <div
        class="btn-group"
        >
        <!-- Player List View -->
        <div class="player-list-container horizontal">
          <div class="player-list">
            @for (player of players; track player; let last = $last) {
              <div
                class="player-list-item"
                [class.active]="isPlayerSelected(player)"
                (click)="selectPlayer(player)"
                [class.border-right]="!last"
                >
                <span class="player-name">
                  {{ player.playLastName }}, {{ player.playFirstName }}
                </span>
                @if (isPlayerScorecardOfficial(player.playerId!)) {
                  <i
                    class="fa fa-check check-icon"
                    >
                  </i>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
    <div class="btn-group">
      <button
        (click)="openPlayerSearchModal()"
        class="btn btn-primary btn-outline"
        >
        <i class="fa fa-search"></i>
      </button>
    </div>
    <div class="btn-toolbar">
      <!-- Hide Official Scorecards checkbox -->
      @if (isVerifyMode()) {
        <div class="panel checkbox-container">
          <label class="checkbox-label">
            <input
              class="checkbox"
              type="checkbox"
              [(ngModel)]="hideOfficialScorecards"
              (change)="handleHideOfficialCheck()"
              />
              <span class="checkbox-text">Hide Official Scorecards</span>
            </label>
          </div>
        }

        <!-- Scorecard counts progress bars -->
        @if (isVerifyMode()) {
          <div class="scorecard-counts">
            <div class="progress-container">
              <div class="progress">
                <div
                  class="progress-bar progress-bar-success"
                  [style.width]="officialPercentage() + '%'"
                  >
                  {{ officialScorecardsCount() }}
                </div>
                <div
                  class="progress-bar progress-bar-warning"
                  [style.width]="unofficialPercentage() + '%'"
                  >
                  {{ unofficialScorecardsCount() }}
                </div>
              </div>
              <div class="progress-labels">
                <span class="label-official"
                  >Official: {{ officialScorecardsCount() }}</span
                  >
                  <span class="label-unofficial"
                    >Unofficial: {{ unofficialScorecardsCount() }}</span
                    >
                  </div>
                </div>
              </div>
            }

            <!-- Show/Hide buttons for verify mode -->
            @if (isVerifyMode()) {
              <div class="btn-group">
                <button
                  [disabled]="!selectedPlayer"
                  class="btn"
          [ngClass]="{
            'btn-primary': showAllScores,
            'btn-default': !showAllScores
          }"
                  (click)="showAllScores = true"
                  >
                  Show
                </button>
                <button
                  [disabled]="!selectedPlayer"
                  class="btn"
          [ngClass]="{
            'btn-primary': !showAllScores,
            'btn-default': showAllScores
          }"
                  (click)="showAllScores = false"
                  >
                  Hide
                </button>
              </div>
            }

            <!-- Scoring type buttons (Group/Scorecard) -->
            @if (isScoresMode()) {
              <div class="btn-group">
                <button
                  class="btn"
          [ngClass]="{
            'btn-primary': scoringType === 'group',
            'btn-default': scoringType !== 'group'
          }"
                  (click)="scoringType = 'group'"
                  >
                  Group
                </button>
                <button
                  class="btn"
          [ngClass]="{
            'btn-primary': scoringType === 'scorecard',
            'btn-default': scoringType !== 'scorecard'
          }"
                  (click)="scoringType = 'scorecard'"
                  >
                  Scorecard
                </button>
              </div>
            }

            <!-- Refresh button -->
            <button class="btn btn-primary btn-outline" (click)="refreshScores()">
              <i class="fa fa-refresh"></i>
            </button>

            <div
              class="legend-hover-container"
              (mouseenter)="showLegend = true"
              (mouseleave)="showLegend = false"
              >
              <button
                class="btn btn-primary btn-outline"
                (click)="$event.preventDefault(); $event.stopPropagation()"
                >
                <i class="fa fa-lg fa-info-circle"></i>
              </button>
              @if (showLegend) {
                <app-scorecard-legend
                  [currentMode]="scorecardMode"
                  class="legend-popup"
                  >
                </app-scorecard-legend>
              }
            </div>
          </div>
          <!-- Scorecards table -->
          <div class="ibox-content">
            <div class="panel panel-default">
              <div class="panel-heading">
                <strong>
                  {{ groupTitle }}
                </strong>
              </div>
              <div class="panel-body">
                <div class="table-responsive">
                  <table class="table table-holes">
                    <thead>
                      <tr>
                        <th
                          [colSpan]="scorecardMode !== 'scores' ? 2 : 1"
                          class="text-align-right"
                          >
                          Hole
                        </th>
                        <th [hidden]="!isScoresMode()" class="text-align-right">
                          Start
                        </th>
                        @for (hole of holesOUT; track hole) {
                          <th>
                            <input
                              #holeInput
                              readonly
                              [tabIndex]=""
                              type="text"
                              value="{{ hole.number }}"
                      [ngClass]="{
                        'start-hole': hole.number === selectedGroup?.startTee,
                        'regular-hole': hole.number !== selectedGroup?.startTee
                      }"
                              />
                            </th>
                          }
                          <th>OUT</th>
                          @for (hole of holesIN; track hole) {
                            <th>
                              <input
                                #holeInput
                                readonly
                                [tabIndex]=""
                                type="text"
                                value="{{ hole.number }}"
                      [ngClass]="{
                        'start-hole': hole.number === selectedGroup?.startTee,
                        'regular-hole': hole.number !== selectedGroup?.startTee
                      }"
                                />
                              </th>
                            }
                            <th>IN</th>
                            <th>RND</th>
                            <th>TTL</th>
                            <th [hidden]="!isVerifyVisible()">Ver.</th>
                            <th>OFF</th>
                          </tr>
                          <tr class="par-row">
                            <th></th>
                            <th class="text-align-right">Par</th>
                            @for (hole of holesOUT; track hole) {
                              <th>{{ hole.par }}</th>
                            }
                            <th></th>
                            @for (hole of holesIN; track hole) {
                              <th>{{ hole.par }}</th>
                            }
                            <th></th>
                            <th></th>
                            <th></th>
                            <th [hidden]="!isVerifyVisible()"></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- Scorecard: Input -->
                          @for (scorecard of filteredScorecards; track scorecard) {
                            <tr>
                              <td [colSpan]="1" [hidden]="!isScoresMode()" class="player">
                                {{ scorecard.playerLastName }},
                                {{ scorecard.playerFirstName }}
                              </td>
                              <td class="text-align-right" [hidden]="isScoresMode()">
                                {{ isVerifyMode() ? "System" : "Score" }}
                              </td>
                              <td>
                                <div
                      [ngClass]="{
                        'text-primary':
                          scorecard.startPlusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scorecard.startPlusMinusDisplay!.startsWith('-'),
                        'text-default': scorecard.startPlusMinusDisplay! === 'E'
                      }"
                                  >
                                  {{ scorecard.startPlusMinusDisplay }}
                                </div>
                              </td>
                              <!-- Scorecard: Input fields -->
                              @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                <td
                                  >
                                  <div class="score-container">
                                    <input
                                      [(ngModel)]="scoreOUT.score"
                        (ngModelChange)="
                          onScoreChange(
                            scoreOUT,
                            scorecard.playerId!,
                            scoreOUT.holeNumber!
                          )
                        "
                                      #scoreInput
                                      appSelectOnFocus
                                      appAutoFocusNext
                                      type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isDirty,
                          'input-syncing': isScoreSyncing(scoreOUT),
                          'input-validation-error': hasValidationError(scoreOUT)
                        }"
                                      [hidden]="!isScoreInputVisible(scoreOUT)"
                        [readonly]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                        [class.readonly]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                                      [attr.data-row-id]="scorecard.playerId"
                                      [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex(scorecard.playerId!, scoreOUT.holeNumber!)
                        "
                                      (keypress)="numberOnly($event)"
                                      (input)="onInputChange($event)"
                        (requestFocusAdvancement)="
                          onRequestFocusAdvancement($event)
                        "
                                      maxlength="2"
                                      />
                                      <!-- Add sync indicator -->
                                      @if (isScoreSyncing(scoreOUT)) {
                                        <div class="sync-badge">
                                          <i class="fa fa-sync fa-spin"></i>
                                        </div>
                                      }
                                      @if (
                                        verifyScoreMode === 'edit' ||
                                        isStatsMode() ||
                                        isScoresMode()
                                        ) {
                                        <button
                        [disabled]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                                          (click)="openShotModal(scorecard, scoreOUT)"
                                          class="btn btn-xs shots-button btn-primary"
                        [ngClass]="{
                          'btn-warning':
                            (scoreOUT.statusCode === 'I' &&
                              scoreOUT.score! > 0) ||
                            scoreOUT.isDirty
                        }"
                                          type="button"
                                          >
                                          Shots
                                        </button>
                                      }
                                    </div>
                                    <div
                                      [hidden]="!isScoreInputVisible(scoreOUT)"
                      [ngClass]="{
                        'text-primary':
                          scoreOUT.plusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scoreOUT.plusMinusDisplay!.startsWith('-'),
                        'text-default': scoreOUT.plusMinusDisplay! === 'E',
                        'has-error': hasScoreValidationError[scoreOUT.scoreId!],
                        'cell-dirty': scoreOUT.isDirty
                      }"
                                      >
                                      {{ scoreOUT.plusMinusDisplay }}
                                    </div>
                                  </td>
                                }
                                <td>
                                  <div
                                    [hidden]="!isScoreTotalVisible('out')"
                      [ngClass]="{
                        'cell-dirty': isOUTTotalDirty(scorecard.scorecardId!)
                      }"
                                    >
                                    {{ getScoresOUTTotal(scorecard.scorecardId!) }}
                                  </div>
                                  <div>&nbsp;</div>
                                </td>
                                @for (scoreIN of scoresIN[scorecard.scorecardId!]; track scoreIN) {
                                  <td>
                                    <div class="score-container">
                                      <input
                                        [(ngModel)]="scoreIN.score"
                        (ngModelChange)="
                          onScoreChange(
                            scoreIN,
                            scorecard.playerId!,
                            scoreIN.holeNumber!
                          )
                        "
                                        #scoreInput
                                        appSelectOnFocus
                                        appAutoFocusNext
                                        type="text"
                        [ngClass]="{
                          'input-dirty': scoreIN.isDirty,
                          'input-syncing': isScoreSyncing(scoreIN),
                          'input-validation-error': hasValidationError(scoreIN)
                        }"
                                        [hidden]="!isScoreInputVisible(scoreIN)"
                        [readonly]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                        [class.readonly]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                                        [attr.data-row-id]="scorecard.playerId"
                                        [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex(scorecard.playerId!, scoreIN.holeNumber!)
                        "
                                        (keypress)="numberOnly($event)"
                                        (input)="onInputChange($event)"
                        (requestFocusAdvancement)="
                          onRequestFocusAdvancement($event)
                        "
                                        maxlength="2"
                                        />
                                        <!-- Add sync indicator -->
                                        @if (isScoreSyncing(scoreIN)) {
                                          <div class="sync-badge">
                                            <i class="fa fa-sync fa-spin"></i>
                                          </div>
                                        }
                                        @if (
                                          verifyScoreMode === 'edit' ||
                                          isStatsMode() ||
                                          isScoresMode()
                                          ) {
                                          <button
                        [disabled]="
                          scorecard.official ||
                          (isVerifyMode() && verifyScoreMode === 'view')
                        "
                                            (click)="openShotModal(scorecard, scoreIN)"
                                            class="btn btn-xs shots-button btn-primary"
                        [ngClass]="{
                          'btn-warning':
                            (scoreIN.statusCode === 'I' &&
                              scoreIN.score! > 0) ||
                            scoreIN.isDirty
                        }"
                                            type="button"
                                            >
                                            Shots
                                          </button>
                                        }
                                      </div>
                                      <div
                                        [hidden]="!isScoreInputVisible(scoreIN)"
                      [ngClass]="{
                        'text-primary':
                          scoreIN.plusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scoreIN.plusMinusDisplay!.startsWith('-'),
                        'text-default': scoreIN.plusMinusDisplay! === 'E',
                        'has-error': hasScoreValidationError[scoreIN.scoreId!],
                        'cell-dirty': scoreIN.isDirty
                      }"
                                        >
                                        {{ scoreIN.plusMinusDisplay }}
                                      </div>
                                    </td>
                                  }
                                  <td>
                                    <div
                                      [hidden]="!isScoreTotalVisible('in')"
                      [ngClass]="{
                        'cell-dirty': isINTotalDirty(scorecard.scorecardId!)
                      }"
                                      >
                                      {{ getScoresINTotal(scorecard.scorecardId!) }}
                                    </div>
                                    <div>&nbsp;</div>
                                  </td>
                                  <td>
                                    <div
                                      [hidden]="!isScoreTotalVisible('rnd')"
                      [ngClass]="{
                        'cell-dirty': isRoundTotalDirty(scorecard.scorecardId!)
                      }"
                                      >
                                      {{
                                      getScoresINTotal(scorecard.scorecardId!) === "-" ||
                                      getScoresOUTTotal(scorecard.scorecardId!) === "-"
                                      ? "-"
                                      : scorecard.roundScore
                                      }}
                                    </div>
                                    <div
                                      [hidden]="!isScoreTotalVisible('rnd')"
                      [ngClass]="{
                        'text-primary':
                          scorecard.roundPlusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scorecard.roundPlusMinusDisplay!.startsWith('-'),
                        'text-default':
                          scorecard.roundPlusMinusDisplay! === 'E',
                        'cell-dirty': isRoundTotalDirty(scorecard.scorecardId!)
                      }"
                                      >
                                      {{
                                      getScoresINTotal(scorecard.scorecardId!) === "-" ||
                                      getScoresOUTTotal(scorecard.scorecardId!) === "-"
                                      ? "-"
                                      : scorecard.roundPlusMinusDisplay
                                      }}
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      [hidden]="!isScoreTotalVisible('tot')"
                      [ngClass]="{
                        'cell-dirty': isTotalDirty(scorecard.scorecardId!)
                      }"
                                      >
                                      {{
                                      getScoresINTotal(scorecard.scorecardId!) === "-" ||
                                      getScoresOUTTotal(scorecard.scorecardId!) === "-"
                                      ? "-"
                                      : scorecard.finishScore
                                      }}
                                    </div>
                                    <div
                                      [hidden]="!isScoreTotalVisible('tot')"
                      [ngClass]="{
                        'text-primary':
                          scorecard.finishPlusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scorecard.finishPlusMinusDisplay!.startsWith('-'),
                        'text-default':
                          scorecard.finishPlusMinusDisplay === 'E',
                        'cell-dirty': isTotalDirty(scorecard.scorecardId!)
                      }"
                                      >
                                      {{
                                      getScoresINTotal(scorecard.scorecardId!) === "-" ||
                                      getScoresOUTTotal(scorecard.scorecardId!) === "-"
                                      ? "-"
                                      : scorecard.finishPlusMinusDisplay
                                      }}
                                    </div>
                                  </td>
                                  <td [hidden]="!isVerifyVisible()">
                                    <app-scorecard-verify
                                      [show]="scorecard.verified ? 'verified' : 'unverified'"
                                    ></app-scorecard-verify>
                                  </td>
                                  <td>
                                    <app-scorecard-verify
                                      [show]="scorecard.official ? 'verified' : 'unverified'"
                                    ></app-scorecard-verify>
                                  </td>
                                </tr>
                              }
                              <!--fwy, gir, ss, putts, dd-->
                              <!-- Stats: fwy -->
                              @for (scorecard of filteredScorecards; track scorecard) {
                                <tr
                                  [hidden]="!isStatsMode()"
                                  >
                                  <th colspan="2" class="text-align-right">F/W</th>
                                  @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                    <td
                                      >
                                      <div>
                                        <input
                                          #scoreInput
                                          type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isFairwayDirty
                        }"
                        [readonly]="
                          scorecard.official || !hasFairway(scoreOUT.holeId!)
                        "
                        [class.readonly]="
                          scorecard.official || !hasFairway(scoreOUT.holeId!)
                        "
                                          [(ngModel)]="scoreOUT.fairwayDisplay"
                                          [attr.data-row-id]="'fairway'"
                                          [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('fairway', scoreOUT.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreOUT, 'fairway', scoreOUT.holeNumber!)
                        "
                                          maxlength="1"
                                          (input)="onYNInputChange($event)"
                                          />
                                        </div>
                                      </td>
                                    }
                                    <td>&nbsp;</td>
                                    @for (scoreIN of scoresIN[scorecard.scorecardId!]; track scoreIN) {
                                      <td>
                                        <div>
                                          <input
                                            #scoreInput
                                            type="text"
                        [ngClass]="{
                          'input-dirty': scoreIN.isFairwayDirty
                        }"
                        [readonly]="
                          scorecard.official || !hasFairway(scoreIN.holeId!)
                        "
                        [class.readonly]="
                          scorecard.official || !hasFairway(scoreIN.holeId!)
                        "
                                            [(ngModel)]="scoreIN.fairwayDisplay"
                                            [attr.data-row-id]="'fairway'"
                                            [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('fairway', scoreIN.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreIN, 'fairway', scoreIN.holeNumber!)
                        "
                                            (input)="onYNInputChange($event)"
                                            maxlength="1"
                                            />
                                          </div>
                                        </td>
                                      }
                                    </tr>
                                  }
                                  <!-- Stats: gir -->
                                  @for (scorecard of filteredScorecards; track scorecard) {
                                    <tr
                                      [hidden]="!isStatsMode()"
                                      >
                                      <th colspan="2" class="text-align-right">GIR</th>
                                      @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                        <td
                                          >
                                          <div>
                                            <input
                                              #scoreInput
                                              type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isGirDirty
                        }"
                                              [readonly]="scorecard.official"
                                              [class.readonly]="scorecard.official"
                                              [(ngModel)]="scoreOUT.girDisplay"
                                              [attr.data-row-id]="'gir'"
                                              [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('gir', scoreOUT.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreOUT, 'gir', scoreOUT.holeNumber!)
                        "
                                              (input)="onYNInputChange($event)"
                                              maxlength="1"
                                              />
                                            </div>
                                          </td>
                                        }
                                        <td>&nbsp;</td>
                                        @for (scoreIN of scoresIN[scorecard.scorecardId!]; track scoreIN) {
                                          <td>
                                            <div>
                                              <input
                                                #scoreInput
                                                type="text"
                        [ngClass]="{
                          'input-dirty': scoreIN.isGirDirty
                        }"
                                                [readonly]="scorecard.official"
                                                [class.readonly]="scorecard.official"
                                                [(ngModel)]="scoreIN.girDisplay"
                                                [attr.data-row-id]="'gir'"
                                                [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('gir', scoreIN.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreIN, 'gir', scoreIN.holeNumber!)
                        "
                                                (input)="onYNInputChange($event)"
                                                maxlength="1"
                                                />
                                              </div>
                                            </td>
                                          }
                                        </tr>
                                      }
                                      <!-- Stats: ss -->
                                      @for (scorecard of filteredScorecards; track scorecard) {
                                        <tr
                                          [hidden]="!isStatsMode()"
                                          >
                                          <th colspan="2" class="text-align-right">S/S</th>
                                          @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                            <td
                                              >
                                              <div>
                                                <input
                                                  #scoreInput
                                                  type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isSandSaveDirty
                        }"
                                                  [readonly]="scorecard.official"
                                                  [class.readonly]="scorecard.official"
                                                  [(ngModel)]="scoreOUT.sandSaveMadeDisplay"
                                                  [attr.data-row-id]="'sandSaveMade'"
                                                  [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('sandSaveMade', scoreOUT.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(
                            scoreOUT,
                            'sandSaveMade',
                            scoreOUT.holeNumber!
                          )
                        "
                                                  maxlength="1"
                                                  (input)="onYNInputChange($event)"
                                                  />
                                                </div>
                                              </td>
                                            }
                                            <td>&nbsp;</td>
                                            @for (scoreIN of scoresIN[scorecard.scorecardId!]; track scoreIN) {
                                              <td>
                                                <div>
                                                  <input
                                                    #scoreInput
                                                    type="text"
                        [ngClass]="{
                          'input-dirty': scoreIN.isSandSaveDirty
                        }"
                                                    [readonly]="scorecard.official"
                                                    [class.readonly]="scorecard.official"
                                                    [(ngModel)]="scoreIN.sandSaveMadeDisplay"
                                                    [attr.data-row-id]="'sandSaveMade'"
                                                    [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('sandSaveMade', scoreIN.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreIN, 'sandSaveMade', scoreIN.holeNumber!)
                        "
                                                    maxlength="1"
                                                    (input)="onYNInputChange($event)"
                                                    />
                                                  </div>
                                                </td>
                                              }
                                            </tr>
                                          }
                                          <!-- Stats: putts -->
                                          @for (scorecard of filteredScorecards; track scorecard) {
                                            <tr
                                              [hidden]="!isStatsMode()"
                                              >
                                              <th colspan="2" class="text-align-right">Putts</th>
                                              @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                                <td
                                                  >
                                                  <div>
                                                    <input
                                                      #scoreInput
                                                      type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isPuttsDirty
                        }"
                                                      [readonly]="scorecard.official"
                                                      [class.readonly]="scorecard.official"
                                                      [(ngModel)]="scoreOUT.putts"
                                                      [attr.data-row-id]="'putts'"
                                                      [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('putts', scoreOUT.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreOUT, 'putts', scoreOUT.holeNumber!)
                        "
                                                      (keypress)="numberOnly($event)"
                                                      (input)="onInputChange($event)"
                                                      maxlength="2"
                                                      />
                                                    </div>
                                                  </td>
                                                }
                                                <td>&nbsp;</td>
                                                @for (scoreIN of scoresIN[scorecard.scorecardId!]; track scoreIN) {
                                                  <td>
                                                    <div>
                                                      <input
                                                        #scoreInput
                                                        type="text"
                        [ngClass]="{
                          'input-dirty': scoreIN.isPuttsDirty
                        }"
                                                        [readonly]="scorecard.official"
                                                        [class.readonly]="scorecard.official"
                                                        [(ngModel)]="scoreIN.putts"
                                                        [attr.data-row-id]="'putts'"
                                                        [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('putts', scoreIN.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreIN, 'putts', scoreIN.holeNumber!)
                        "
                                                        (keypress)="numberOnly($event)"
                                                        (input)="onInputChange($event)"
                                                        maxlength="2"
                                                        />
                                                      </div>
                                                    </td>
                                                  }
                                                </tr>
                                              }
                                              <!-- Stats: dd -->
                                              @for (scorecard of filteredScorecards; track scorecard) {
                                                <tr
                                                  [hidden]="!isStatsMode()"
                                                  >
                                                  <th colspan="2" class="text-align-right">D/D</th>
                                                  @for (scoreOUT of scoresOUT[scorecard.scorecardId!]; track scoreOUT) {
                                                    <td
                                                      >
                                                      <div>
                                                        <input
                                                          #scoreInput
                                                          type="text"
                        [ngClass]="{
                          'input-dirty': scoreOUT.isDriveDistanceDirty
                        }"
                        [readonly]="
                          scorecard.official ||
                          !isDriveMeasured(scoreOUT.holeId!)
                        "
                        [class.readonly]="
                          scorecard.official ||
                          !isDriveMeasured(scoreOUT.holeId!)
                        "
                                                          [(ngModel)]="scoreOUT.driveDistanceDisplay"
                                                          [attr.data-row-id]="'driveDistance'"
                                                          [attr.data-hole-number]="scoreOUT.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('driveDistance', scoreOUT.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(
                            scoreOUT,
                            'driveDistance',
                            scoreOUT.holeNumber!
                          )
                        "
                                                          (keypress)="numberOnly($event)"
                                                          (input)="onInputChange($event)"
                                                          maxlength="3"
                                                          />
                                                        </div>
                                                      </td>
                                                    }
                                                    <td>&nbsp;</td>
                                                    @for (scoreIN of scoresIN[scorecard.scorecardId!]; track
                                                      scoreIN.scoreId) {
                                                      <td>
                                                        <div>
                                                          <input
                                                            #scoreInput
                                                            type="text"
                        [class]="{
                          'input-dirty': scoreIN.isDriveDistanceDirty
                        }"
                        [readonly]="
                          scorecard.official ||
                          !isDriveMeasured(scoreIN.holeId!)
                        "
                        [class.readonly]="
                          scorecard.official ||
                          !isDriveMeasured(scoreIN.holeId!)
                        "
                                                            [(ngModel)]="scoreIN.driveDistanceDisplay"
                                                            [attr.data-row-id]="'driveDistance'"
                                                            [attr.data-hole-number]="scoreIN.holeNumber"
                        [attr.tabindex]="
                          getTabIndex('driveDistance', scoreIN.holeNumber!)
                        "
                        (ngModelChange)="
                          setStat(scoreIN, 'driveDistance', scoreIN.holeNumber!)
                        "
                                                            (keypress)="numberOnly($event)"
                                                            (input)="onInputChange($event)"
                                                            maxlength="3"
                                                            />
                                                          </div>
                                                        </td>
                                                      }
                                                    </tr>
                                                  }
                                                  <!-- Stats: Actions -->
                                                  <tr
                  [hidden]="
                    !isStatsMode() || scorecards.length === 0 || !selectedPlayer
                  "
                                                    >
                                                    <td [colSpan]="holes.length + 5">
                                                      <div class="stats-actions">
                                                        <div class="actions-buttons">
                                                          <button
                                                            [disabled]="dirtyScoreCount() === 0"
                                                            (click)="saveDirtyScores()"
                                                            class="btn btn-primary"
                                                            type="button"
                                                            >
                                                            <i class="fa fa-save"></i> Save
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                  <!-- Verify: Input -->
                                                  @for (scorecard of filteredScorecards; track scorecard) {
                                                    <tr
                                                      [hidden]="!isVerifyMode()"
                                                      >
                                                      <td [colSpan]="1" class="text-align-right">Verify</td>
                                                      <td>
                                                        <div
                      [ngClass]="{
                        'text-primary':
                          scorecard.startPlusMinusDisplay!.startsWith('+'),
                        'text-danger':
                          scorecard.startPlusMinusDisplay!.startsWith('-'),
                        'text-default': scorecard.startPlusMinusDisplay! === 'E'
                      }"
                                                          >
                                                          {{ scorecard.startPlusMinusDisplay }}
                                                        </div>
                                                      </td>
                                                      @for (
                                                        verifyScoreOUT of verifyScoresOUT; track
                                                        verifyScoreOUT; let index = $index) {
                                                        <td
                                                          >
                                                          <div>
                                                            <input
                                                              #scoreInput
                                                              [readonly]="verifyScoreMode === 'edit'"
                                                              [class.readonly]="verifyScoreMode === 'edit'"
                                                              [tabIndex]="index"
                                                              appSelectOnFocus
                                                              appAutoFocusNext
                                                              [attr.data-row-id]="'verify'"
                                                              [attr.data-hole-number]="verifyScoreOUT.holeNumber"
                        [ngClass]="{
                          'input-error':
                            verifyScoreOUT.score && !verifyScoreOUT.valid
                        }"
                                                              type="text"
                                                              [value]="verifyScoreOUT.score"
                                                              (input)="onVerifyScoreChange($event, index, 'OUT')"
                                                              (keypress)="numberOnly($event)"
                                                              (input)="onInputChange($event)"
                                                              maxlength="2"
                                                              />
                                                            </div>
                                                          </td>
                                                        }
                                                        <td>
                                                          <div
                      [ngClass]="{
                        'text-error': !validOUT
                      }"
                                                            >
                                                            {{ getVerifyScoresTotal("OUT") }}
                                                          </div>
                                                        </td>
                                                        @for (
                                                          verifyScoreIN of verifyScoresIN; track
                                                          verifyScoreIN; let index = $index) {
                                                          <td
                                                            >
                                                            <div>
                                                              <input
                                                                [readonly]="verifyScoreMode === 'edit'"
                                                                [class.readonly]="verifyScoreMode === 'edit'"
                                                                #scoreInput
                                                                [tabIndex]="index + 9"
                                                                appSelectOnFocus
                                                                appAutoFocusNext
                                                                [attr.data-row-id]="'verify'"
                                                                [attr.data-hole-number]="verifyScoreIN.holeNumber"
                        [ngClass]="{
                          'input-error':
                            verifyScoreIN.score && !verifyScoreIN.valid
                        }"
                                                                type="text"
                                                                [value]="verifyScoreIN.score"
                                                                (keypress)="numberOnly($event)"
                                                                (input)="onVerifyScoreChange($event, index, 'IN')"
                                                                maxlength="2"
                                                                />
                                                              </div>
                                                            </td>
                                                          }
                                                          <td>
                                                            <div
                      [ngClass]="{
                        'text-error': !validIN
                      }"
                                                              >
                                                              {{ getVerifyScoresTotal("IN") }}
                                                            </div>
                                                          </td>
                                                          <td>
                                                            <div
                      [ngClass]="{
                        'text-error': !validIN || !validOUT
                      }"
                                                              >
                                                              {{ getVerifyScoresTotal("RND") }}
                                                            </div>
                                                          </td>
                                                          <td>
                                                            <div
                      [ngClass]="{
                        'text-error': !validIN || !validOUT
                      }"
                                                              >
                                                              {{ getVerifyScoresTotal("TOTAL") }}
                                                            </div>
                                                          </td>
                                                          <td colspan="2"></td>
                                                        </tr>
                                                      }
                                                      <!-- Verify: Actions -->
                                                      <tr [hidden]="!isVerifyMode() || scorecards.length === 0">
                                                        <td [colSpan]="holes.length + 5">
                                                          <div class="verify-actions">
                                                            <div>
                                                              <div class="actions-buttons">
                                                                <div
                            [hidden]="
                              verifyScoreMode === 'edit' ||
                              isOfficial() ||
                              !selectedPlayer
                            "
                                                                  >
                                                                  <button
                                                                    id="editScoresButton"
                                                                    (click)="editVerifyScores()"
                                                                    class="verify btn btn-primary"
                                                                    type="button"
                                                                    >
                                                                    <i class="fa fa-edit"></i> Edit Scores
                                                                  </button>
                                                                </div>
                                                                <div
                            [hidden]="
                              verifyScoreMode === 'view' || isOfficial()
                            "
                                                                  >
                                                                  <button
                                                                    (click)="saveDirtyScores()"
                                                                    class="verify btn btn-primary"
                                                                    type="button"
                                                                    >
                                                                    <i class="fa fa-save"></i> Save Scores
                                                                  </button>
                                                                </div>
                                                                <div
                            [hidden]="
                              verifyScoreMode === 'view' || isOfficial()
                            "
                                                                  >
                                                                  <button
                                                                    (click)="cancelScoreEdits()"
                                                                    class="verify btn btn-primary"
                                                                    type="button"
                                                                    >
                                                                    <i class="fa fa-times"></i> Cancel Edits
                                                                  </button>
                                                                </div>
                                                                <div
                            [hidden]="
                              isOfficial() ||
                              verifyScoreMode === 'edit' ||
                              !selectedPlayer
                            "
                                                                  >
                                                                  <button
                                                                    id="markOfficial"
                                                                    [disabled]="!canMarkOfficial()"
                                                                    (click)="markOfficial()"
                                                                    class="verify btn btn-primary"
                                                                    type="button"
                                                                    >
                                                                    <i class="fa fa-check-circle"></i> Mark Official
                                                                  </button>
                                                                </div>
                                                                <div [hidden]="!isOfficial()">
                                                                  <button
                                                                    (click)="markOfficial()"
                                                                    class="verify btn btn-primary"
                                                                    type="button"
                                                                    >
                                                                    <i class="fa fa-times-circle"></i> Mark Unofficial
                                                                  </button>
                                                                  <div
                                                                    [hidden]="!timestampOfficial"
                                                                    class="verify-status"
                                                                    >
                                                                    Marked Official on<br />
                                                                    {{ timestampOfficial | date : "yyyy-MM-dd" }}
                                                                    at
                                                                    {{ timestampOfficial | date : "h:mm:ss a" }}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td colspan="3"></td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
